
import Vue, { PropType } from 'vue';
import CustomAddButton from './CustomAddButton.vue';
import Draw16 from '@carbon/icons-vue/es/draw/16';
import Image16 from '@carbon/icons-vue/es/image/16';
import TextCreation16 from '@carbon/icons-vue/es/text--creation/16';

export default Vue.extend({
  name: 'EmptyPrintPosition',
  components: {
    CustomAddButton,
    Draw16,
  },
  props: {
    canvasSelection: {
      type: Object as PropType<{
        x: number;
        y: number;
        width: number;
        height: number;
      }>,
      required: true,
    },
  },
  data() {
    const MAX_WIDTH = 437;
    const MAX_HEIGHT = 250;
    const width =
      this.canvasSelection.width * 0.9 > MAX_WIDTH
        ? MAX_WIDTH
        : this.canvasSelection.width * 0.9;
    const height =
      this.canvasSelection.height * 0.5 > MAX_HEIGHT
        ? MAX_HEIGHT
        : this.canvasSelection.height * 0.5;
    // const topDistance =
    //   this.canvasSelection.y + this.canvasSelection.height / 2 - height / 2;
    const minTopDistance =
      this.canvasSelection.y + this.canvasSelection.height / 2 - height / 2;

    const minLeftDistance =
      this.canvasSelection.x + this.canvasSelection.width / 2 - width / 2;

    // const btnWidth = width / 2 - 7;
    const btnHeight = height / 2;
    const btnTop = height / 2 - btnHeight / 2;
    const correctionFactor = 35;
    return {
      MAX_WIDTH,
      MAX_HEIGHT,
      Image16,
      TextCreation16,
      // width,
      height,
      // topDistance,
      minLeftDistance,
      // btnWidth,
      // btnHeight,
      btnTop,
      correctionFactor,
      minTopDistance,
    };
  },
  computed: {
    topDistance(): number {
      const distance = this.canvasSelection.y - this.correctionFactor + 5;
      return distance < this.minTopDistance ? this.minTopDistance : distance;
    },
    leftDistance(): number {
      const width =
        this.canvasSelection.width * 0.9 > this.MAX_WIDTH
          ? this.MAX_WIDTH
          : this.canvasSelection.width * 0.9;
      return (
        this.canvasSelection.x + this.canvasSelection.width / 2 - width / 2
      );
    },

    width(): number {
      return this.canvasSelection.width * 0.9 > this.MAX_WIDTH
        ? this.MAX_WIDTH
        : this.canvasSelection.width * 0.9;
    },

    btnWidth(): number {
      return (
        (this.canvasSelection.width * 0.9 > this.MAX_WIDTH
          ? this.MAX_WIDTH
          : this.canvasSelection.width * 0.9) /
          2 -
        7
      );
    },

    btnHeight(): number {
      return (
        (this.canvasSelection.height * 0.5 > this.MAX_HEIGHT
          ? this.MAX_HEIGHT
          : this.canvasSelection.height * 0.5) / 2
      );
    },
  },
});
